var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcPadGeneratorInteractionModel = require('../ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var DfnPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(DfnPadGeneratorInteractionModel, IpcPadGeneratorInteractionModel);
DfnPadGeneratorInteractionModel.$class = 'DfnPadGeneratorInteractionModel';

module.exports = DfnPadGeneratorInteractionModel;

DfnPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    IpcPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.componentFamily = this.shadow("componentFamily",
        function() {
            return self.data.componentFamily();
        },
        function(value) {
            return self.data.componentFamily(value);
        },
        [self.data.componentFamily]
    );

    this.horizontalPinPitch = this.shadow("horizontalPinPitch",
        function() {
            return self.data.horizontalPinPitch() / self.getUnitFactor();
        },
        function(value) {
            value = parseFloat(value);

            //update lead span
            self.horizontalLeadToLeadSpanMax(value + self.padWidthMax());
            self.horizontalLeadToLeadSpanMin(value + self.padWidthMin());

            return self.data.horizontalPinPitch(value * self.getUnitFactor());
        }, [
            self.data.horizontalPinPitch, this.userSettingsModel.distanceUnit
        ]
    );
};

DfnPadGeneratorInteractionModel.prototype.getInspectorElementForComponentFamily = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('componentFamily', 'Component Family'), this.componentFamily, this.componentFamilyList())];
};

DfnPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

DfnPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

DfnPadGeneratorInteractionModel.prototype.componentFamilyList = function() {
    throw new Error("Not implemented.");
};

DfnPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintDfn2));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForComponentFamily());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};
